// $(window).load(function() {
//   $("body").removeClass("preload");
// });

window.onload = (event) => {
 $("body").removeClass("preload");
};








const options = {
  root: null,
  //The root is the container which observes the scroll & element intersections.
  // "null" defaults to the browser viewport, so we're watching if elements enter the frame of browser window
  rootMargin: '0px',
  //Add margin to frame that the intersection observer observes. Can be written as '0px 10px 30px 20px' for different margin side sizes.
  threshold: 0.4
  //if 50% of the card is visible in the viewport, trigger the callback function (revealing the card)
}

const callback = (entries, observer) => {
  //look at all intersection observer event entries reported
  entries.forEach(entry => {
    //if the event entry is of a target element intersecting with the observer
    if (entry.isIntersecting){
        entry.target.classList.add("fade--in");
    }
  });
};

const observer = new IntersectionObserver(callback, options);

//Tell the intersection observer to watch all card elements, then trigger the callback when their intersection status changes.
const targets = document.querySelectorAll('.js-show-on-scroll');
targets.forEach((target) => {
  observer.observe(target);
});
